import { Button, ButtonProps } from "@mui/material";
import { useStylesCss } from "./AppButtons.styles";

const FlowConfirmButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...props.sx, ...classes.general };
  const myProps = {
    sx: myClasses,
    ...props,
  };
  return (
    <Button variant="contained" {...myProps} /*color="primary"*/>
      {props.children}
    </Button>
  );
};
export default FlowConfirmButton;
